import React, { useEffect } from 'react';
import css from './HelloVideo.module.css';

// Plays a hello video over the page (no navigation). Esc / backdrop / ✕ close it.
const HelloVideoModal = ({ video, name, onClose }) => {
  useEffect(() => {
    const onKey = e => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  if (!video) return null;
  return (
    <div className={css.modalBackdrop} role="dialog" aria-modal="true" aria-label={`Hello video from ${name || 'this listener'}`} onClick={onClose} data-hello-video-modal="true">
      <div className={css.modalBox} onClick={e => e.stopPropagation()}>
        <button type="button" className={css.modalClose} onClick={onClose} aria-label="Close video">✕</button>
        <video className={css.modalVideo} src={video.url} poster={video.poster} controls autoPlay playsInline />
        {name ? <p className={css.modalName}>Hello from {name}</p> : null}
      </div>
    </div>
  );
};

export default HelloVideoModal;
